module.exports = __webpack_public_path__ + "img/instagram.a1cb2c5a.svg";